import ActivePowerChartPresenter from "./Chart/ActivePowerChartPresenter";

export const ActivePowerChart = {
    Chart : ActivePowerChartPresenter
}